import {ChangeDetectionStrategy, Component, computed, inject, input, model, resource} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {DxPopupModule} from 'devextreme-angular';
import {ProductionService} from '../../../../../core/services/gestion-production/production.service';
import {QuantiteProduitComplementaireDTO} from '../../../../../core/dtos/produit/declinaison/complementaire/quantite-produit-complementaire-dto';

/** Consultation, non modifiable, de la commande d'origine d'une ligne de plan de production issue d'un produit complémentaire. */
@Component({
  selector: 'yo-dialog-commande-produit-complementaire',
  templateUrl: './dialog-commande-produit-complementaire.component.html',
  styleUrls: ['./dialog-commande-produit-complementaire.component.scss'],
  imports: [DxPopupModule, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogCommandeProduitComplementaireComponent {

  private readonly productionSvc = inject(ProductionService);

  readonly planProductionDetailId = input<number | null>(null);
  readonly visible = model<boolean>(false);

  /** La requête ne part qu'à l'ouverture de la popup. */
  private readonly params = computed(() =>
    this.visible() && this.planProductionDetailId() ? this.planProductionDetailId() : undefined);

  private readonly commandeResource = resource({
    params: this.params,
    defaultValue: null as QuantiteProduitComplementaireDTO | null,
    loader: ({params}) => this.productionSvc.findCommandeProduitComplementaire(params)
  });

  readonly commande = this.commandeResource.value;
  readonly isLoading = this.commandeResource.isLoading;

  close = (): void => this.visible.set(false);
}
